<script setup lang="ts">
import { cloneDeep } from 'lodash'

import { getOppositeParticipant } from '@collector/shared-ui-domain'
import { SubParticipantPosition } from '@collector/sportsapi-client-legacy'
import Button from '@mobile/components/Button/Button.vue'
import { useIncidentGroupComponents } from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/composables/useIncidentGroupComponents'
import IncidentBasicInfo from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/IncidentBasicInfo.vue'
import PlayerSelectGroup from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/PlayerSelectGroup.vue'
import Modal from '@mobile/views/Relation/DetailsPanel/Modals/Modal.vue'
import ModalButtons from '@mobile/views/Relation/DetailsPanel/Modals/ModalButtons.vue'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

import { useThrowPositionDetailsModalForm } from '../components/ThrowPositionDetailsModal/composables'
import { groups } from './consts'

interface Props {
  linkedIncident: ProbableLinkedIncident
}

const props = defineProps<Props>()

// emits
const emit = defineEmits(['close'])

// composables
const { probableHomeParticipant, probableAwayParticipant } =
  useEventInjections()

// data
const localLinkedIncident = cloneDeep(props.linkedIncident)
const participant = localLinkedIncident.participant!
const oppositeParticipant = getOppositeParticipant(
  participant.id,
  probableHomeParticipant.value,
  probableAwayParticipant.value,
)

// composables
const incidentGroupComponentsComposable = useIncidentGroupComponents(
  localLinkedIncident,
  groups,
)
const {
  updateIncident: _updateIncident,
  removeAttribute,
  addAttribute,
} = incidentGroupComponentsComposable
const { goalkeeper } = useThrowPositionDetailsModalForm(
  localLinkedIncident,
  removeAttribute,
  addAttribute,
  new Map(),
  new Map(),
)

// methods
function updateIncident(): void {
  const goalkeeper_id = goalkeeper.value

  _updateIncident({ goalkeeper_id })

  emit('close')
}
</script>

<template>
  <Modal id="incidentDetailsModal">
    <IncidentBasicInfo :linkedIncident />

    <PlayerSelectGroup
      v-model="goalkeeper"
      important
      name="Goalkeeper"
      nullable
      :filterByPosition="SubParticipantPosition.Goalkeeper"
      :isFulfilled="!!goalkeeper"
      :participant="oppositeParticipant"
    />

    <ModalButtons>
      <Button
        color="red"
        size="lg"
        @click="$emit('close')"
      >
        Close
      </Button>
      <Button
        class="px-8"
        color="green"
        size="lg"
        @click="updateIncident"
      >
        Save
      </Button>
    </ModalButtons>
  </Modal>
</template>
